<template>
    <div>
        <loading
            :active.sync="loadingApp"
            :can-cancel="false"
            :is-full-page="true"
            :color="'#0B8BCC'"
            :loader="'dots'"
            :opacity="0.7"
            :lock-scroll="true"
        ></loading>
        <Toast
            :show.sync="toast.show"
            :message="toast.message"
            :tipe="toast.tipe"
            @close="toast.show = false"
            :position="toast.position"
            :icon="toast.icon"
        ></Toast>
        <!-- App Header -->
        <div class="appHeader bg-primary text-light">
            <div class="left">
                <a
                    href="Javascript:;"
                    class="headerButton"
                    @click="$router.go(-1)"
                >
                    <ion-icon name="chevron-back-outline"></ion-icon>
                </a>
            </div>
            <div class="pageTitle">Target Affiliate</div>
            <div class="right">
                <a
                    href="Javascript:;"
                    class="headerButton"
                    @click="actionSheetFilter('show')"
                >
                    <ion-icon name="filter-sharp"></ion-icon>
                </a>
            </div>
        </div>
        <!-- * App Header -->
        <div id="appCapsule" v-if="loadingApp == false">
            <div
                class="section curved-header pt-1"
                style="--height-curved: 50px"
            >
                <div class="wallet-card">
                    <div class="balance">
                        <div class="col-6 text-left">
                            <div
                                class="title"
                                style="display: flex; align-items: center"
                            >
                                <span class="mr-1">Transaksi Downline</span>
                            </div>
                            <h1 class="total">
                                <span>{{
                                    dataTargetAffiliate.transaction_downline
                                        | rupiah
                                }}</span>
                            </h1>
                        </div>
                        <div class="col-6 text-left">
                            <div
                                class="title"
                                style="display: flex; align-items: center"
                            >
                                <span class="mr-1">Bonus Komisi</span>
                            </div>
                            <h1 class="total">
                                <span
                                    >Rp
                                    {{
                                        dataTargetAffiliate.bonus_komisi
                                            | rupiah
                                    }}</span
                                >
                            </h1>
                        </div>
                    </div>
                    <!-- <div class="wallet-footer">
                        <a
                            class="btn btn-primary btn-block"
                            href="https://blog.qiosfin.com/penghasilan-pasif-program-agen-affiliate-qiosfin/"
                            target="_blank"
                        >
                            Pelajari tentang Target Affiliate disini!
                        </a>
                    </div> -->
                </div>
            </div>
            <div class="section" style="margin-top: 50px">
                <div
                    class="alert alert-grey-custom mb-2"
                    v-if="customer.affiliate_type == 'REGULER'"
                >
                    <h4 class="mt-1" style="font-weight: bold">
                        ⚠️ Akses Eksklusif!
                    </h4>
                    <p style="font-size: 10px; line-height: 18px">
                        Fitur ini hanya untuk Agen Affiliate Plus.<br />
                        💡 Upgrade sekarang untuk mulai mengumpulkan bonus
                        komisi dari transaksi downline Anda!<br />
                        🎯 Jangan lewatkan kesempatan ini!
                    </p>
                    <router-link
                        :to="{ name: 'referral.upgrade' }"
                        class="btn btn-warning btn-sm btn-block mb-1"
                    >
                        Upgrade Sekarang!
                    </router-link>
                </div>
                <div class="alert alert-warning-custom mb-2">
                    <h5 class="mt-1" style="font-weight: bold">
                        Bonus Komisi Makin Besar! 🤑
                    </h5>
                    <p
                        class="text-secondary mb-1"
                        style="font-size: 12px; line-height: 18px"
                    >
                        Dapatkan bonus komisi s.d jutaan rupiah dari transaksi
                        downline, semakin banyak transaksi downline kamu,
                        semakin besar bonus komisi yang kamu dapatkan.
                    </p>
                </div>
                <div>
                    <ul class="listview image-listview inset m-0">
                        <li>
                            <div class="item">
                                <div class="icon-box bg-light">
                                    <ion-icon name="calendar-sharp"></ion-icon>
                                </div>
                                <div class="in">
                                    <div>Periode {{ monthSelected }}</div>
                                    <span
                                        class="badge badge-info-custom"
                                        v-if="
                                            daysRemaining > 0 &&
                                            daysRemaining >= 5
                                        "
                                        >{{ daysRemaining }} hari lagi</span
                                    >
                                    <span
                                        class="badge badge-danger-custom"
                                        v-else-if="
                                            daysRemaining > 0 &&
                                            daysRemaining < 5
                                        "
                                        >{{ daysRemaining }} hari lagi</span
                                    >
                                    <span class="badge badge-grey-custom" v-else
                                        >Selesai</span
                                    >
                                </div>
                            </div>
                        </li>
                        <li>
                            <router-link
                                :to="{ name: 'referral.target.terms' }"
                                class="item"
                            >
                                <div class="icon-box bg-light">
                                    <ion-icon name="trophy-sharp"></ion-icon>
                                </div>
                                <div class="in">
                                    <div>Lihat Rewards & Ketentuan</div>
                                </div>
                            </router-link>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="section" style="margin-top: 30px">
                <h4>Posisi pencapaian saat ini</h4>
                <div class="steps pl-2">
                    <div
                        class="step"
                        v-for="item in dataTargetAffiliate.tier"
                        :key="item.target"
                        :class="item.completed ? 'completed' : ''"
                    >
                        <div class="circle">✔</div>
                        <div class="step-title">
                            <h4 class="mb-0" style="font-weight: bold">
                                {{ item.target | rupiah }}
                                Transaksi Downline
                            </h4>
                            <p class="mb-0" style="line-height: 15px">
                                <small
                                    >Bonus Komisi sebesar
                                    <b>Rp {{ item.bonus | rupiah }}</b>
                                </small>
                            </p>
                        </div>
                    </div>
                </div>
                <p style="font-size: 12px; line-height: 18px">
                    📈 Semakin banyak transaksi downline, semakin besar bonus
                    yang Anda dapatkan! 🚀
                </p>
            </div>
        </div>
        <action-sheet ref="filter" :title="'Filter'" :inset="true">
            <div class="form-group boxed">
                <div class="alert alert-warning-custom mb-2">
                    <p class="mb-0">
                        Data yang dapat ditampilkan hanya 3 bulan terakhir
                    </p>
                </div>
                <select
                    name=""
                    class="form-control"
                    v-model="dataTargetAffiliate.month_selected"
                    @change="btnApplyFilter()"
                >
                    <option
                        v-for="(month, index) in filterMonth"
                        :key="index"
                        :value="month.value"
                    >
                        {{ month.label }}
                    </option>
                </select>
            </div>
            <div class="form-group basic mt-1 pb-0">
                <div class="row">
                    <div class="col-12">
                        <button
                            class="btn btn-outline-primary btn-block btn-lg"
                            style="height: 40px; border-width: 1px"
                            @click="btnResetFilter()"
                        >
                            Reset
                        </button>
                    </div>
                </div>
            </div>
        </action-sheet>
    </div>
</template>
<script>
    import $axios from '../../../api.js';
    import { mapActions, mapState } from 'vuex';
    import moment from 'moment';
    export default {
        data() {
            return {
                affiliate_id: '',
                loadingApp: true,
                komisi: {
                    data: [],
                },
                komisi_total: 0,
                filterMonth: [
                    {
                        value: moment().format('MM-YYYY'), // Format MM-YYYY
                        label: `Bulan ini - ${moment().format('MMMM YYYY')}`, // Teks deskriptif
                    },
                    {
                        value: moment().subtract(1, 'month').format('MM-YYYY'), // Bulan lalu
                        label: `Bulan Lalu - ${moment()
                            .subtract(1, 'month')
                            .format('MMMM YYYY')}`,
                    },
                    {
                        value: moment().subtract(2, 'month').format('MM-YYYY'), // Bulan sebelumnya lagi
                        label: moment()
                            .subtract(2, 'month')
                            .format('MMMM YYYY'), // Hanya nama bulan dan tahun
                    },
                ],
                dataTargetAffiliate: {
                    month_selected: moment().format('MM-YYYY'),
                    transaction_downline: 0,
                    bonus_komisi: 0,
                    tier: [],
                },
            };
        },
        computed: {
            ...mapState(['toast', 'VUE_ENV', 'customer', 'setting']),
            monthSelected() {
                return moment(
                    this.dataTargetAffiliate.month_selected,
                    'MM-YYYY'
                ).format('MMMM YYYY');
            },
            daysRemaining() {
                // Ambil bulan dan tahun dari month_selected
                const [month, year] =
                    this.dataTargetAffiliate.month_selected.split('-');

                // Validasi format bulan dan tahun
                if (!month || !year || isNaN(month) || isNaN(year)) {
                    return null; // Jika format tidak valid, kembalikan null
                }

                // Buat tanggal untuk hari ini
                const today = new Date();

                // Buat tanggal untuk akhir bulan
                const lastDayOfMonth = new Date(year, month, 0); // Bulan berikutnya, hari ke-0 = akhir bulan sebelumnya

                // Hitung selisih hari
                const timeDiff = lastDayOfMonth - today; // Selisih dalam milidetik
                const daysDiff = Math.ceil(timeDiff / (1000 * 60 * 60 * 24)); // Konversi ke hari
                return daysDiff >= 0 ? daysDiff : 0; // Pastikan tidak negatif
            },
        },
        methods: {
            ...mapActions(['getCustomer', 'getSetting']),
            dateMutation(date) {
                return moment(date).format('D MMM YYYY H:mm:ss');
            },
            actionSheetFilter(value) {
                let element = this.$refs.filter.$el;
                window.$(element).modal(value);
            },
            btnResetFilter() {
                this.dataTargetAffiliate.month_selected =
                    moment().format('MM-YYYY');
                this.actionSheetFilter('hide');
                this.getDataTargetAffiliate();
            },
            btnApplyFilter() {
                this.actionSheetFilter('hide');
                this.getDataTargetAffiliate();
            },
            getDataTargetAffiliate() {
                this.loadingApp = true;
                $axios
                    .get('/referral/target', {
                        params: this.dataTargetAffiliate,
                    })
                    .then(response => {
                        this.dataTargetAffiliate = response.data.data;
                        this.loadingApp = false;
                    })
                    .catch(() => {
                        this.loadingApp = false;
                    });
            },
        },
        mounted() {
            this.getDataTargetAffiliate();
        },
        destroyed() {
            this.$store.commit('RESET_TOAST');
        },
    };
</script>
<style>
    .step {
        position: relative;
        padding-left: 40px;
        margin: 30px 0;
    }

    .step-title {
        font-size: 1em;
        color: #555;
    }

    .circle {
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        width: 24px;
        height: 24px;
        border: 2px solid #ccc;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: white;
    }

    .completed .circle {
        border-color: #0b8bcc;
        background-color: #0b8bcc;
        color: white;
    }

    .step::before {
        content: '';
        position: absolute;
        left: 10px;
        top: 12px;
        width: 5px;
        height: 76px;
        background-color: #ccc;
        z-index: -1;
    }

    .step.completed::before {
        background-color: #0b8bcc; /* Garis hijau untuk langkah selesai */
    }

    .step:last-child::before {
        display: none;
    }
</style>
